import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'NavBanner',
})(({ brandColors, breakpoints, type, typography, spacing }) => ({
  topBanner: {
    background:
      'linear-gradient(270deg, rgba(116, 107, 26, 0.12) 0%, rgba(116, 107, 26, 0.06) 100%)',
    padding: `0 ${typography.pxToRem(24)}`,
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    color: brandColors.offWhite,
    '& a': {
      textDecoration: 'none',
    },
    [breakpoints.up('sm')]: {
      padding: `${typography.pxToRem(4)} ${typography.pxToRem(40)}`,
    },
    [breakpoints.up('md')]: {
      padding: `${typography.pxToRem(4)} ${typography.pxToRem(64)}`,
      display: 'flex',
    },
    [breakpoints.up('lg')]: {
      padding: `${typography.pxToRem(4)} ${typography.pxToRem(80)}`,
    },
  },
  topBannerLight: {
    background: `linear-gradient(270deg, rgba(116, 107, 26, 0.12) 0%, rgba(116, 107, 26, 0.06) 100.08%)`,
  },
  topBannerDark: {
    background: `linear-gradient(270deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.06) 100.08%)`,
  },
  onLightText: {
    color: brandColors.mediumBlue,
    '&:hover, &:focus': {
      color: brandColors.primaryMain,
    },
  },
  onDarkText: {
    color: brandColors.white,
    '&:hover, &:focus': {
      color: brandColors.offWhite,
    },
  },
  locationContainer: {
    display: 'none',
    [breakpoints.up('md')]: {
      display: 'block',
    },
  },
  bannerItem: {
    flex: 1,
  },
  contact: {
    ...type['14_medium'],
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: spacing(1),
    [breakpoints.up('md')]: {
      justifyContent: 'flex-end',
    },
    '& > a:only-child': {
      margin: '0 auto',
    },
  },
  promo: {
    ...type['14_medium'],
    flex: 1,
    display: 'none',
    textAlign: 'center',
    [breakpoints.up('md')]: {
      display: 'block',
      width: 'fit-content',
      margin: '0 auto',
    },
    '&:hover, &:focus': {
      textDecoration: 'underline',
    },
  },
  phone: {
    display: 'flex',
    minHeight: typography.pxToRem(48),
    padding: `${typography.pxToRem(12)} ${typography.pxToRem(8)}`,
    justifyContent: 'center',
    alignItems: 'center',
    gap: typography.pxToRem(6),
    '&:hover, &:focus': {
      textDecoration: 'underline',
    },
  },
  login: {
    display: 'none',
    padding: `${typography.pxToRem(12)} ${typography.pxToRem(8)}`,
    '&:hover, &:focus': {
      textDecoration: 'underline',
    },
    [breakpoints.up('md')]: {
      display: 'unset',
    },
  },
}));

export default useStyles;
